import { render, staticRenderFns } from "./Sklad.vue?vue&type=template&id=a8ead54a&scoped=true&"
import script from "./Sklad.vue?vue&type=script&lang=js&"
export * from "./Sklad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ead54a",
  null
  
)

export default component.exports